import React, { FC, useContext, useReducer } from 'react';
import { AppAction } from './actions';
import reducer from './reducer';
import { initialStateValue, AppState } from './states';

export interface Store {
  state: AppState;
  dispatch: React.Dispatch<AppAction> | {};
}

const AppContext = React.createContext<Store>({
  state: initialStateValue,
  dispatch: () => ({}),
});

export const useStateContext = (): Store => useContext(AppContext);

export const GlobalStateProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialStateValue);
  return <AppContext.Provider value={{ state, dispatch }}> {children}</AppContext.Provider>;
};
